
export const getDeviceType = (type) => {
    return ['mobile', 'tablet', 'desktop'].indexOf(type) < 0 ? 'desktop' : type;
};

